module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7eUeG"))).then(() => module.bundle.root('hEqeo'));